import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Gallery } from './components/Gallery';

const App: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-background text-text font-serif selection:bg-stone-300 selection:text-text">
      <Navbar />
      
      <main>
        <Hero />
        <Gallery />
        
        {/* Placeholder sections for About/Contact to make nav links work visually */}
        <section id="exhibitions" className="min-h-[50vh] flex flex-col justify-center items-center bg-[#F7F5F0] px-12 py-24 border-t border-text/5">
          <h2 className="font-serif text-4xl italic mb-8">Exhibitions</h2>
          <div className="text-center font-sans text-sm tracking-widest leading-loose uppercase">
            <p>Muscat Art Exhibition "Oman" — 2025</p>
            <p>Beirut National Exhibition "Lebanon" — 2020</p>
            <p>C-Art Gallery "Syria" — 2016</p>
          </div>
        </section>

        <section id="about" className="min-h-[60vh] flex flex-col justify-center items-center bg-white py-24 px-8">
          <div className="max-w-3xl flex flex-col items-center text-center">
            <h2 className="font-serif text-4xl italic mb-8">The Artist</h2>
            <p className="font-sans text-sm leading-8 text-stone-600 mb-6">
              With nearly four decades of experience behind the easel, Dardo’s work is the result of a lifelong dedication to the craft. While many mediums exist, Dardo found a true home in oil on canvas—the only material rich enough to fully articulate the depth of his vision.
            </p>
            <p className="font-sans text-sm leading-8 text-stone-600 mb-8">
              Every painting is an original concept, born from a specific idea but designed to remain open. Dardo believes that a painting is never truly finished until it is viewed. He invites every observer to bring their own emotions and experiences to the canvas, interpreting the story in a way that resonates personally with them.
            </p>
            <p className="font-sans text-xs tracking-widest uppercase border-b border-text/20 pb-1 cursor-pointer hover:border-text transition-colors">
              Read Biography
            </p>
          </div>
        </section>
        
        <section id="contact" className="py-24 bg-[#1C1C1C] text-[#F7F5F0] flex flex-col items-center justify-center text-center">
          <h2 className="font-serif text-3xl italic mb-8">Inquiries</h2>
          <p className="font-sans text-sm tracking-widest mb-2">INQUIRE@DARDOART.COM</p>
          <p className="font-sans text-sm tracking-widest opacity-60">Via della Luce 4, Milano</p>
          
          <div className="mt-16 text-[10px] opacity-40 font-sans tracking-widest">
            © 2024 DARDO ART. ALL RIGHTS RESERVED.
          </div>
        </section>
      </main>
    </div>
  );
};

export default App;